module.exports = __webpack_public_path__ + "media/assets/images/pq3_old-d310a113c8d01d4aae935b4b2f6b0611.svg";